import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import { MovieGLightbox } from "../../common/image_gallery.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const gallery_data = document.querySelector("#_gallery-section");
	let url = `/misc/immagini/${gallery_data.dataset.ct}/${gallery_data.dataset.id}/`;
	if (gallery_data.dataset.qs) {
		url = `${url}?${gallery_data.dataset.qs}`;
	}
	const main_gallery = new MovieGLightbox({
		url: url,
		per_page: 20,
		selector: gallery_data.dataset.gallerySelector,
	});

	if (gallery_data.dataset.galleryAlbum) {
		for (const el of document.querySelectorAll(
			gallery_data.dataset.galleryAlbum,
		)) {
			el.addEventListener("click", (event) => {
				event.preventDefault();
				let album_url = `/misc/immagini/${el.dataset.ct}/${el.dataset.id}/`;
				if (el.dataset.qs) {
					album_url = `${album_url}?${el.dataset.qs}`;
				}
				new MovieGLightbox({ url: album_url });
			});
		}
	}

	endlessPaginate({
		onCompleted: (context, fragment) => {
			const endless_url = new URL(context.url, window.location.origin);
			const page = Number.parseInt(endless_url.searchParams.get(context.key));
			main_gallery.fetchPage(page);
		},
	});
});
